import { useCallback } from "react";

import { mapFacultyFormData } from "@/admin/AdminConsoleFacultyDirectoryPage/AdminConsoleFacultyAdderModal/AdminConsoleFacultyAdderModal.utils";
import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useAdminConsoleAddFacultyPost = () => {
  const createEventRecordRequest = useCallback((facultyAdderState) => {
    const payload = mapFacultyFormData(facultyAdderState);
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${API_BASE_URL}/api/v2/faculty/`, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useAdminConsoleAddFacultyPost;
